"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.LABELED_CONTROL_POSITIONS = void 0;
var LABELED_CONTROL_POSITIONS = Object.freeze({
  left: 'left',
  right: 'right'
});
exports.LABELED_CONTROL_POSITIONS = LABELED_CONTROL_POSITIONS;